module.exports = require("./uz-Latn");